var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroupIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.563,
    height: 21.758,
    viewBox: "0 0 27.563 21.758",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico-group",
    transform: "translate(-1.531 -14.479)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M40.043,23.27a4.4,4.4,0,1,0-4.4-4.4A4.4,4.4,0,0,0,40.043,23.27Zm0-7.714a3.319,3.319,0,1,1-3.319,3.319A3.323,3.323,0,0,1,40.043,15.556Z",
    transform: "translate(-24.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M17.373,37.937a2.828,2.828,0,1,0-2.828-2.828A2.831,2.831,0,0,0,17.373,37.937Zm0-4.579a1.751,1.751,0,1,1-1.751,1.751A1.753,1.753,0,0,1,17.373,33.358Z",
    transform: "translate(-10.09 -12.35)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M69.815,37.937a2.828,2.828,0,1,0-2.828-2.828A2.831,2.831,0,0,0,69.815,37.937Zm0-4.579a1.751,1.751,0,1,1-1.751,1.751A1.753,1.753,0,0,1,69.815,33.358Z",
    transform: "translate(-46.472 -12.35)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M26.812,48.883a5.77,5.77,0,0,0-2.431.538,9.3,9.3,0,0,0-11.2,0A5.754,5.754,0,0,0,5,54.634v1.051a.538.538,0,0,0,.538.538H9.484c-.015.213-.023.427-.023.643v1.771a.538.538,0,0,0,.538.538H27.564a.538.538,0,0,0,.538-.538V56.867c0-.216-.008-.431-.023-.643h3.945a.538.538,0,0,0,.538-.538V54.633A5.757,5.757,0,0,0,26.812,48.883ZM6.077,55.147v-.513a4.675,4.675,0,0,1,6.188-4.423,9.313,9.313,0,0,0-2.644,4.936ZM27.026,58.1H10.538V56.867a8.244,8.244,0,1,1,16.488,0Zm4.461-2.953H27.943A9.309,9.309,0,0,0,25.3,50.211a4.675,4.675,0,0,1,6.188,4.423Z",
    transform: "translate(-3.469 -22.94)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupIcon);
export default __webpack_public_path__ + "static/media/groupIcon.346e4f610d039d48bc7423c19fdee573.svg";
export { ForwardRef as ReactComponent };